import { BaseUrls } from './base.urls';
/**
 * AWSUrls class contains all urls for vendors who support AWS based clould backend
 *
 * @export
 * @extends {BaseUrls}
 */
export class AWSUrls extends BaseUrls {
    constructor(
        authHost: string,
        restServerHost: string,
        algoServerHost: string,
        flaskServerHost: string,
        fastApiServerHost: string,
        optionCalculatorServer: string,
        uGateWay: string,
        aiAssistantServer: string,
        ekycServer: string,
        operatorServer: string,
        aiRecommendationServer: string,
        analyticsServer: string,
    ) {
        super(authHost, restServerHost, algoServerHost, flaskServerHost, fastApiServerHost, optionCalculatorServer, uGateWay, aiAssistantServer, ekycServer, operatorServer, aiRecommendationServer, analyticsServer);
    }

    initUrls() {
        // authServerAddress is auth host without '/v1'
        const authServerAddress = this.authServerHost;
        this.fastApiHost = this.fastApiServerHost + 'api/';
        const authDomain = authServerAddress.replace('accounts/', '');
        this.adminHost = `${this.authServerHost}api/v1/admin/`;
        this.retailHost = `${this.authServerHost}api/v1/retail/`;
        this.profileServerHost = `${this.authServerHost}api/v1/profile/`;
        this.brokerServerHost = `${this.profileServerHost}broker/`;
        this.brokerPlanFailure = `${this.profileServerHost}planFunds/`;
        this.payin = `${this.authServerHost}api/v1/funds/deposit/`;
        this.status = `${this.authServerHost}api/v1/funds/status/`;
        this.fetchMargin = `${this.authServerHost}api/v1/funds/margin/`;
        this.fetchSwastikaMargin = `${this.uGateWayURL}/api/v1/limits/limits/`;
        this.fetchMastertrustMargin = `${this.uGateWayURL}ugateway/masterTrust/api/v1/limits/limits/`;
        this.transactionHistory = `${this.authServerHost}api/v1/funds/transactionHistory/`;
        this.marginBlocked = this.fastApiHost + 'funds/margin/';
        this.authServerHost = `${this.authServerHost}api/v1/auth/`;
        this.affiliateHost = `${authServerAddress}api/v1/affiliate/`;
        this.affiliateHostLogin = this.affiliateHost + 'auth/';
        this.operatorDashboardHost = this.operatorServer + 'api/v1/';

        this.phoneLogin = this.authServerHost + 'login/';
        this.validateMobileOTP = this.authServerHost + 'loginOtp/validate/phone'
        this.resendOTPLink = this.authServerHost + 'loginOtp/resendOtp/';   // TODO: Remove this
        this.verifyPhone = this.authServerHost + 'loginOtp/verify_phone/';

        if (this.restServerHost) {
            this.login = this.restServerHost + 'api/V2/dashboard/login/';
        } else {
            this.login = this.authServerHost + 'login/';
        }
        this.uGateWayLogin = this.uGateWayURL + '/api/v1/auth/login/';
        this.mastertrustLogin = `${this.uGateWayURL}ugateway/masterTrust` + '/api/v1/auth/login/';
        this.logoutUser = this.authServerHost + 'logout/';
        this.cancelConnectBroker = this.logoutUser + 'cancelConnectBroker/';
        this.fogot = this.authServerHost + 'fogot/';
        this.lastSession = this.authServerHost + 'logout/lastSession';
        this.logoutSessions = this.authServerHost + 'logout';
        this.consentToken = this.authServerHost + 'consent';

        this.signUpUrl = this.authServerHost + 'signup/';
        this.verifyEmail = this.authServerHost + 'signup/verify_email/';
        this.validateOTP = this.authServerHost + 'signup/validate/';

        this.sendEmailOtp = this.authServerHost + 'loginOtp/verify_email_otp/';
        this.verifyEmailOtp = this.authServerHost + 'loginOtp/verify_communication_email_otp/'

        this.resetPassword = this.authServerHost + 'reset/';
        this.changePassword = this.authServerHost + 'reset/changePassword/';

        this.verifyMPIN = this.authServerHost + 'mpin/';
        this.setMPIN = this.authServerHost + 'mpin/setMPIN/';
        this.forgotMpin = this.authServerHost + 'mpin/forgotMPIN/';

        this.geolocationAPIUrl = 'https://api.ipify.org/?format=json'; // as angular normalizes the url, we need to use the full url for checking in http-interceptor

        this.otp = this.authServerHost + 'otp/';

        this.socialLoginInit = this.authServerHost + 'oAuthLogin/init_login/';
        this.socialLoginCallBack = this.authServerHost + 'oAuthLogin/callback/';

        // this.passwordPolicy = this.authServerHost + 'passwordPolicy/';

        // Masters
        this.scripMaster = authServerAddress + `masters/scrip.js?r=${new Date().toDateString()}`;
        this.indicesMaster = authServerAddress + `masters/indices.js/?r=${new Date().toDateString()}`;
        this.symbolInfoMaster = authServerAddress + `masters/symbolInfo.js/?r=${new Date().toDateString()}`;
        this.userManualLink = authDomain + `getUserManual`

        // Market Watch
        this.marketWatchList = this.flaskServerHost + 'listMarketWatch';
        this.ohlcFirstFetch = this.flaskServerHost + 'ohlcFirstFetch'

        this.staticData = this.flaskServerHost + 'symboldetails/';
        this.symbolData = this.flaskServerHost + 'staticData';
        this.marketWatchItems = this.algoServerHost + 'api/market_data/add_symbol/';

        // Admin Urls
        this.plans = this.adminHost + 'plans/';
        this.defaultPricing = this.adminHost + 'plans/prices/default/'
        this.pricing = this.adminHost + 'plans/prices/';
        this.timeConfig = this.adminHost + 'time/';
        this.timeConfigReset = this.adminHost + 'time/default/'
        this.ums = this.adminHost + 'client/';
        this.activeUsers = this.adminHost + 'client/active/';
        this.supportedBrokers = this.adminHost + 'broker/supported/';
        this.clientsBrokers = this.adminHost + 'broker/settings/';
        this.inbuiltAlgoList = this.adminHost + 'plans/inbuiltAlgo/';
        this.toggleAlgoProvider = this.adminHost + 'client/toggleAlgoProvider/';

        this.getPaymentStaticData = this.adminHost + 'plans/config/';

        // Profile Urls
        this.picture = this.profileServerHost + 'picture/';

        // Plans & Payemnts URL
        this.details = authServerAddress + 'v2/api/profile/account/details/';
        this.updateDetails = authServerAddress + 'api/v1/profile/details/';
        this.planInfo = authServerAddress + 'v2/api/profile/account/user/current-plan/';
        this.paymentsServerUrl = authDomain + 'payments/';
        this.plansCatalog = this.paymentsServerUrl + 'api/v1/catalog/plans/';
        this.plansSubscribe = this.paymentsServerUrl + 'api/v1/plan/subscribe/';
        this.plansCancel = this.paymentsServerUrl + 'api/v1/plan/cancel/';
        this.plansToggleAutopay = this.paymentsServerUrl + 'api/v1/plan/toggle-autopay/';
        this.plansTransactionHistory = this.paymentsServerUrl + 'api/v1/transactions/summary/';
        this.planSubscriptionStatus = this.paymentsServerUrl + 'api/v1/chargebee/hosted-page/';
        this.signedRedirectUrl = this.paymentsServerUrl + 'api/v1/auth/signed-redirect-url/';
        this.walletUrl = this.paymentsServerUrl + 'api/v1/wallet/';

        this.brokerFormSettings = this.brokerServerHost + 'settings/form';
        this.brokerSettings = this.brokerServerHost + 'settings/';
        this.brokerSession = this.algoServerHost + 'api/generic/broker_session/';
        this.profilePlans = this.profileServerHost + 'plans/';

        this.activeSessions = this.profileServerHost + 'details/activeSessions';
        this.isSessionLoggedIn = this.authServerHost + 'activeSession/';

        // Books Url
        this.getOrderBook = this.fastApiHost + 'books/orders/';
        this.getTradeBook =  this.fastApiHost +  'books/trades/';
        this.getPositionBook =  this.fastApiHost +  'books/positions/';

        // Net User Margin Urls
        this.netUserProfit = this.fastApiHost + 'analytics/net_user_profit/'
        this.exportReportAsPdf = this.algoServerHost + 'api/analytics/net_user_profit/'
        this.strategyWisePnl = this.fastApiHost + 'analytics/stg_wise_pnl/'

        // Retail url
        this.checkPermissions = this.retailHost + 'check-permissions/'


        // Algo Creation and updation

        this.algoCreationUpdating = this.algoServerHost + 'api/generic/rapid_algo/';
        this.loadStrategy = this.algoServerHost + 'api/generic/load_strategy/';
        this.listAlgos = this.flaskServerHost + 'listAlgos';
        this.listActiveCompletedAlgos = this.flaskServerHost + 'listActiveCompletedAlgos';
        this.algoExecution = this.algoServerHost + 'api/generic/rapid_strategy/';
        this.updateAlgoState = this.algoServerHost + 'api/generic/update_algo_state/'
        this.updateStateForAllAlgos = this.algoServerHost + 'api/generic/all_strategies/'
        this.indicatorList = this.fastApiHost + 'algos/technical_indicators/';
        this.paramsDetection = this.fastApiHost + 'generic/text_mode/';
        this.timeConfiguration = this.fastApiHost + 'algos/time_configuration/'

        // backtest
        this.backTest = this.fastApiHost + "backtest/"
        this.backTestIterations = this.backTest + 'iterations/';
        this.backTestCharts = this.fastApiHost + 'backtestCharts/';

        //orders
        this.placeOrder = this.algoServerHost + 'api/orders/rapid/';
        this.orderSocket = this.algoServerHost.replace('http', 'ws') + 'api/orders/stream/';

        // resend Verify Email Link Url
        this.resendLink = this.authServerHost + 'resendLink/'

        // Config URK
        this.serverConfig = this.algoServerHost + 'api/static_data/config_params/';

        // Cache
        this.getCache = this.algoServerHost + 'api/cache/get/';
        this.setCache = this.algoServerHost + 'api/cache/set/';

        // Pay-off curve
        this.getGreeks = this.optionCalculatorServer + 'api/option_calculator/greeks/';
        this.payOffCurve = this.optionCalculatorServer + 'api/option_calculator/payoff_curve/';
        this.getOptionPrice = this.optionCalculatorServer + 'api/option_calculator/option_price/';
        this.getIV = this.optionCalculatorServer + 'api/option_calculator/iv/';

        // PORTFOLIO
        this.portfolioUrl = this.fastApiHost + 'portfolio'

        //accept portfolio
        this.acceptPortfolio = this.algoServerHost + 'api/portfolio/update_share_portfolio_status/';

        // Portfolio Marketplace URLs
        this.portfolioOrigin = this.fastApiHost + 'portfolio';
        this.portfolioMarketPlace = this.portfolioOrigin + '/marketplace/';
        this.portfolioSubscribe = this.algoServerHost + 'api/portfolio' + '/subscribe';
        this.portfolioBookmark = this.algoServerHost + 'api/portfolio' + '/bookmark';

        this.getCreatedPortfolio =  this.portfolioOrigin  + '/created/';
        this.getPortfolioFromStatus = this.portfolioOrigin  + '/deployed';
        this.getSubscribedPortfolio = this.portfolioOrigin  + '/subscribed/';
        this.getDeployedPortfolio = this.portfolioOrigin  + '/deployed/';
        this.getBookmarkedPortfolio = this.portfolioOrigin   + '/bookmarked/';
        this.getSharedPortfolio = this.portfolioOrigin  + '/shared/';

        // Portfolio Execution URLs
        this.updatePortfolioState = this.algoServerHost + 'api/v3/portfolio/state/';
        this.checkPortfolioRegulation = this.algoServerHost + 'api/v3/portfolio/regulatory-disclosure/';
        this.updatePortfolioStateAdmin = this.algoServerHost + 'api/admin/portfolio/state/';
        this.squareOffPortfolio = this.algoServerHost + 'api/portfolio/squareOff/';
        this.runPortfolio = this.algoServerHost + 'api/portfolio/state/';
        this.backtestState = this.algoServerHost + 'api/portfolio/backtest/';
        this.updateMultiplier = `${this.algoServerHost}api/portfolio/modify/`;

        // Panic Control URLs
        this.panicControl = this.algoServerHost + 'api/v3/portfolio/all/';
        this.panicControlAdmin = this.algoServerHost + 'api/admin/portfolio/all/';
        this.resumePortfolios = this.algoServerHost + 'api/portfolio/bulk_requests/';

        //autoDeployment Portfolios
        this.autoDeployPortfolios = this.portfolioOrigin + '/autodeploy/'

        // Portfolio CRUD URLs
        this.createPortfolio = this.algoServerHost + 'api/portfolio/';
        this.updatePortfolio = this.algoServerHost + 'api/portfolio/';
        this.getPortfolioDetails = this.algoServerHost + 'api/portfolio/';
        this.updateExitParams = this.createPortfolio + 'set_exit_conditions/';
        this.getExitParams = this.createPortfolio + 'get_exit_conditions/';
        this.resetExitParams = this.createPortfolio + 'reset_exit_conditions/';
        this.copyPortfolio = this.createPortfolio + 'copy/';
        this.updateCopyPortfolioVersion = this.createPortfolio + 'update_portfolio_version/';


        // Margin calculator
        this.calculateMargin = this.optionCalculatorServer + 'api/margin/calculate/';
        this.calculatePeakMargin = this.optionCalculatorServer + 'api/margin/peakMargin/';
        this.calculateRequiredMargin = this.optionCalculatorServer + 'api/margin/strikePrice/';

        // Plans and pricing
        this.subscribePlan = this.algoServerHost + 'api/subscription/create/';
        this.cancelPlan = this.algoServerHost + 'api/subscription/cancel/';
        this.upgradePlan = this.algoServerHost + 'api/subscription/upgrade/';
        this.estimate = this.algoServerHost + 'api/subscription/estimate/';
        this.verifyVPA = this.algoServerHost + 'api/payment/hdfc/verifyVpa/';
        this.immediateCancel = this.algoServerHost + 'api/admin/immediateCancel/';
        this.toggleAutoPay = this.algoServerHost + 'api/subscription/toggleAutoPay/';
        this.getCouponById = this.algoServerHost + 'api/subscription/getCouponById/';
        this.subscribedCount = this.algoServerHost + 'api/subscription/subscribedCount/';
        this.recurringSuccess = this.algoServerHost + 'api/subscription/updateRecurringPopupValue/';
        this.listPromotionPlans = this.profileServerHost + 'plans/listPromotionPlans/';
        this.getPlanApproval = this.algoServerHost + "api/subscription/getPlanApproval/";

        // Notifications
        this.createNotification = this.flaskServerHost + 'v2/api/notifications/';
        this.updateNotification = this.createNotification + 'read';
        this.markNotifiactionAsRead = this.createNotification + 'persistant/read'
        this.updateNotificationPreference = this.algoServerHost + 'api/notification/settings/';

        // Transaction History
        this.getTransactionHistory = this.algoServerHost + 'api/subscription/history/';
        this.downloadInvoice = this.algoServerHost + 'api/subscription/invoice/';

        // Get Mapping
        this.getMapping = this.authServerHost + 'shareIndia/mapping/';

        // Affiliate
        this.affiliateProfile = this.affiliateHost + 'auth/profile/';
        this.affiliateLeads = this.affiliateHost + 'leads/';
        this.affiliateFunds = this.flaskServerHost + 'affiliate/funds';
        this.forgotPasswordAffiliate = this.affiliateHost + 'auth/reset_password/';
        // this.affiliateMarginBlocked = this.affiliateHost +  'marginBlocked'; ?from_time=1677675040&to_time=1690894240&page_index=1&page_size=10&order_by=margin_unblocked_time&order_direction=DESC
        this.dealerClientsList = this.affiliateHost + 'dealer/clientslist/';

        // Global Exit Parameters
        this.globalExitUrl = this.algoServerHost + 'api/portfolio/global/exit/';
        this.globalExitStatus = this.algoServerHost + 'api/portfolio/global/exit/status/';

        // share
        this.listShareClients = this.profileServerHost + 'details/listClients/';
        this.shareWithClients = this.createPortfolio + 'share/';

        // One AI
        this.getConversations =  this.aiAssistantServer + 'api/ai/v2/listThreads/';
        this.getConversationByID = this.aiAssistantServer + 'api/ai/v2/listMessages/';
        this.toggleStarThread = this.aiAssistantServer + 'api/ai/v2/toggleStarThread/';
        this.deleteConversation = this.aiAssistantServer + 'api/ai/v2/deleteThread/';
        this.createNewConversation = this.aiAssistantServer + 'api/ai/v2/createThread/';
        this.sendMessage = this.aiAssistantServer + 'api/ai/v2/sendMessage/';
        this.stopResponse = this.aiAssistantServer + 'api/ai/v2/stop/';

        this.validateYml = this.aiAssistantServer + 'api/portfolio/validateFromYml/';
        this.saveYmlPortfolio = this.aiAssistantServer + 'api/portfolio/createFromYml/';
        this.aiSocketStream = this.aiAssistantServer + 'api/aiassistant/ai-stream/';
        this.aiCreditUsage = this.fastApiServerHost + 'api/accounts/usage';
        this.portfolioVersionsUrl = this.aiAssistantServer + 'api/portfolio/portfolio/';
        

        // AI Recommendation
        this.aiRecommendedOriginals = this.aiRecommendationServer + '/allocate_capital';
        this.aiBacktest = this.aiRecommendationServer + '/allocate_capital_historical_date_range_async';
        this.aiBacktestStatus = this.aiRecommendationServer + '/allocate_capital_historical_date_range_async_status';
        this.sendFeedback = this.aiRecommendationServer + '/threads/';

        // Screener
        this.screenerUrl = this.analyticsServer + "screener/";
        this.getRecentScreenersUrl = this.screenerUrl + "list-screeners";
        this.getStarredScreenersUrl = this.screenerUrl + "list-starred-screeners";
        this.getScreenerUrl = this.screenerUrl + "get-screener"
        this.toggleStarScreenerUrl = this.screenerUrl + "toggle-star-screener"
        this.deleteScreenerUrl = this.screenerUrl + "delete-screener"


        // Market Watch
        this.marketWatchUrl = this.algoServerHost + 'api/market_watch/get_all/';
        this.marketWatchUpdate = this.algoServerHost + 'api/market_watch/update/';
        this.singleSymbolData = this.algoServerHost + 'api/symbol/get_details';
        this.setCacheUrl = this.algoServerHost + 'api/cache/set/';
        this.getCacheUrl = this.algoServerHost + 'api/cache/get/';

        // ekyc
        this.fnoEnable = this.ekycServer + 'forms/fno/';

        // retain multiplier
        this.retainMultiplier = this.algoServerHost + 'api/portfolio/remove/retain_multiplier';
        this.setRetainMultiplier = this.adminHost + 'plans/updateRetainMultiplier/';

        // Margin Summary
        this.getBrokerMarginBlocked = this.optionCalculatorServer + 'api/margin/v1/blocked/';
        this.getBrokerPeakMargin = this.optionCalculatorServer + 'api/margin/v1/peak/';

        //operator
        this.loginOperator = this.operatorDashboardHost + 'auth/login/';
        this.loginClients = this.operatorDashboardHost + 'clientAuth/loginClients/';
        this.logoutClients = this.operatorDashboardHost + 'clientAuth/logoutClients';
        this.isLastSession = this.operatorDashboardHost + 'clientAuth/isLastSession';
        
        this.uploadOperatorClientMap = this.operatorDashboardHost + 'clientDetails/upsertOperatorClientDetails/';
        this.getClientDeployedPortfolio = this.operatorDashboardHost + 'clientDetails/getDeployedPortfolio/';
        this.getClietInfo = this.operatorDashboardHost + 'clientDetails/getClientInfo/';
        this.getClientsDetails =  this.operatorDashboardHost + 'clientDetails/getClientDetails/'
        this.getOperatorClientDetails = this.operatorDashboardHost + 'clientDetails/getOperatorClientDetails/';
        this.getClientMarginDetails = this.operatorDashboardHost + 'clientDetails/getClientMarginDetails/';
        this.getSelectedStrategies = this.operatorDashboardHost + 'clientDetails/getClientCache/';
        this.updateSelectedStrategies = this.operatorDashboardHost + 'clientDetails/saveClientCache/';

        this.getClientPortfolioDetails = this.operatorDashboardHost + 'portfolio/getClientPortfolioDetails/';
        this.updateBulkPortfolioState = this.operatorDashboardHost + 'portfolio/updateBulkPortfolioState/';
        this.uploadOperatorStrategyMultiplierMap = this.operatorDashboardHost + 'portfolio/upsertPortfolioMultiplier/';
        this.squareOffPortfolioState = this.operatorDashboardHost + 'portfolio/squareOffPortfolioState/';
        this.clientBooks = this.operatorDashboardHost + 'books/clientBooks/';
        
        this.getOperatorClientMappings = this.operatorDashboardHost + 'admin/getAllOperatorClientMappings/';
        this.assignOperatorClients = this.operatorDashboardHost + 'admin/assignOperatorClients/';
        this.makeClientOperator = this.operatorDashboardHost + 'admin/makeClientOperator/';
        this.adminLoginOperator = this.operatorDashboardHost + 'admin/login/';
        this.modifyRunningPortfolio = this.operatorDashboardHost + 'portfolio/modifyRunningPortfolio/';
        this.updateSharePortfolioStatus = this.operatorDashboardHost + 'portfolio/updateSharePortfolioStatus/';

        //Multi Broker Specific URLs
        this.multiBrokerAuthServerHost = `${authServerAddress}v2/api/`;
        this.multiBrokerEmailPhoneLogin = this.multiBrokerAuthServerHost + 'auth/mobile/send-otp';
        this.multiBrokerResendOTP = this.multiBrokerAuthServerHost + 'auth/mobile/resend-otp';
        this.multiBrokerVerifyOTP = this.multiBrokerAuthServerHost + 'auth/mobile/verify-otp';
        this.validateUsername = this.multiBrokerAuthServerHost + 'auth/direct';
        this.multiBrokerRefreshToken = this.multiBrokerAuthServerHost + 'auth/refresh-token';
        this.getBrokers = this.multiBrokerAuthServerHost + 'static/vendors/';
        this.getAvailableBrokers = this.multiBrokerAuthServerHost + 'profile/broker/schemas';
        this.getConnectedBrokers = this.multiBrokerAuthServerHost + 'profile/broker/';
        this.getAlgoSpaces = this.fastApiServerHost + 'api/profile/virtual-spaces/';
        this.mapAlgoSpace = this.multiBrokerAuthServerHost + 'profile/virtual-spaces/brokers/';
        this.loginBroker = this.multiBrokerAuthServerHost + 'auth/oauth/';
        this.passwordPolicy = this.multiBrokerAuthServerHost + 'auth/password-policy';
        this.directLogin = this.multiBrokerAuthServerHost + 'auth/direct/';
        this.userLogout = this.multiBrokerAuthServerHost + 'profile/account/sessions/logout';
        this.isEmailRegistered = this.multiBrokerAuthServerHost + 'auth/mobile/is-email-registered';
        this.isPhoneRegistered = this.multiBrokerAuthServerHost + 'auth/mobile/is-mobile-registered';
        this.updateUserDetails = this.multiBrokerAuthServerHost + 'auth/mobile/update-user';
        this.verifyInitialDetailsEmailOtp = this.multiBrokerAuthServerHost + 'auth/mobile/verify-otp-user';
        this.resendInitialDetailsOtp = this.multiBrokerAuthServerHost + 'auth/mobile/resend-otp-user';
    }

    getBrokerLogoutURL(broker: string) {
        return this.brokerServerHost + `settings/${broker}/logout/`;
    }

    getMultiBrokerSocialLoginInitURL(provider: string): string{
        return this.multiBrokerAuthServerHost + `auth/oauth/${provider}/init`;
    }

    getMultiBrokerLoginInitURL(provider: string): string {
        return this.multiBrokerAuthServerHost + `auth/oauth/${provider}/broker/init`;
    }

    getMultiBrokerSocialLoginCallback(provider: string): string {
        return this.multiBrokerAuthServerHost + `auth/oauth/${provider}/callback`;
    }
}
